import { ReloadOutlined, UploadOutlined } from '@ant-design/icons';
import { Form, Spin } from 'antd';
import moment from 'moment';
import React, { useState } from 'react'
import { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { HAPUS_IFUNDEFINE } from 'services';
import _Api from 'services/Api/_Api';
import { Button_, Input_, Number_, Select_ } from 'services/Forms/FormsSatu';
import { msg } from 'services/Toastr/Notify/_Toastr';
import Guidles from './Guidles';
import KebutuhanEnergiMakronutrien from './KebutuhanEnergiMakronutrien';

function PerhitunganEnergiDewasa(pr) {



    const [data, setdata] = useState({})
    const [loading, setloading] = useState(false)
    const FORM_ID = 2
    const KONSELING_ID = pr.konseling_id

    const getCombo = () => {
        _Api.get("/get-combo-form?form_id=" + FORM_ID + "&konseling_id=" + KONSELING_ID).then(res => {
            // setcombo(res)
            var dt = res.data.combo
            var rc = res.data.record
            setdata(rc)
            // setlistDiet(res.data.listdiet)


            // frm.setFieldsValue(rc)

            var initfield = {}

            rc.map(gg => {
                if (gg.tipedata == "checkbox") {
                    initfield.centang = { ...initfield.centang, [gg.fiel_fk]: gg.value == 1 }
                } else
                    if (gg.tipedata == "textbox") {
                        initfield[gg.fiel_fk] = gg.value
                    } else
                        if (gg.tipedata == "int") {
                            initfield[gg.fiel_fk] = parseInt(gg.value)
                        } else
                            if (gg.tipedata == "date") {
                                initfield[gg.fiel_fk] = moment(gg.value)
                            } else
                                if (gg.tipedata == "multiple" && gg.value != undefined) {
                                    var vlll = gg.value.split(",")
                                    initfield[gg.fiel_fk] = vlll
                                }
            })
            frm.setFieldsValue(initfield)
            setTimeout(() => {
                hitungSemua()
            }, 100);
        })

    }

    useEffect(() => {
        getCombo()
    }, [pr])

    function hitungBMR(jenisKelamin, bb, tb, usia) {
        if (jenisKelamin === "L") {
            return (10 * bb) + (6.25 * tb) - (5 * parseInt(usia)) + 5;
        } else {
            return (10 * bb) + (6.25 * tb) - (5 * parseInt(usia)) - 161;
        }
    }




    const [frm] = Form.useForm()
    const objDewasa = [
        { "label": "Nama", "field": "nama", "keterangan": "-", "disabled": true, },
        { "label": "Jenis Kelamin", "field": "jeniskelamin_id", "keterangan": "Isi Perempuan (P)/ Laki-laki (L)", "disabled": true, },
        { "label": "Usia (thn)", "field": "umur", "keterangan": "-", "disabled": true, satuan: "tahun" },
        { "label": "Berat Badan yang dipakai", "field": "bb", "keterangan": "kg", satuan: "kg", tipe: "number", disabled: true },
        { "label": "Tinggi Badan yang dipakai", "field": "tb", "keterangan": "cm", satuan: "cm", tipe: "number", disabled: true },
        { "label": "LILA", "field": "lila", "keterangan": "cm", satuan: "cm", tipe: "number" },
        { "label": "Panjang Ulna", "field": "panjang_ulna", "keterangan": "cm", satuan: "cm", tipe: "number" },
        { "label": "Lingkar betis", "field": "lingkar_betis", "keterangan": "cm", satuan: "cm", tipe: "number" },
        { "label": "BB LILA", "disabled": true, "field": "bb_lila", "keterangan": "(4xLILA)-50 kg (Cattermole, 2016)", tipe: "number" },
        { "label": "BB Ideal", "disabled": true, "field": "bb_ideal", "keterangan": "90% (TB-100) cm", tipe: "number" },
        { "label": "BB Adjusted", "disabled": true, "field": "bb_adjusted", "keterangan": "(BB awal-BB ideal)*25+BBI", },
        { "label": "TB Ulna", "disabled": true, "field": "tb_ulna", "keterangan": "L: 97,252 + 2,645 x panjang ulna (cm)\nP: 68,777 + 3,536 x panjang ulna (cm) (Ilayperuma, 2010)" },
        { "label": "IMT", "disabled": true, "field": "imt", "keterangan": "-", satuan: "(kg/m2)" },
        { "label": "Status Gizi Dewasa (<70y)", "disabled": true, "field": "status_gizi_dewasa", "keterangan": "Standar WHO Western Pacific Region (2000), bener ga yang Asia pake ini?" },
        { "label": "Status Gizi Lansia (>=70 y)", "disabled": true, "field": "status_gizi_lansia", "keterangan": "GLIM criteria of malnutrition (Cederholm, 2019)" },
    ];

    const rumusEnergiMiffin = [
        { label: "BMR (kkal)", field: "bmr", disabled: true },
        { label: "Faktor Aktivitas", field: "faktor_aktivitas", tipe: "number" },
        { label: "Faktor Stress", field: "faktor_stress", },
        { label: "TEE (kkal)", field: "tee", disabled: true }
    ];

    const iretonJonesDataMCU = [
        { label: "Trauma (T)", keterangan: "Ya=1, Tidak=0", field: "trauma", tipe: "select" },
        { label: "Burn (B)", keterangan: "Ya=1, Tidak=0", field: "burn", tipe: "select" },
        { label: "Obese (BMI >27)", keterangan: "Yes=1, No=0", field: "obese", disabled: true },
        {
            label: "Ireton-Jones 2002 Revised",
            keterangan: "1784 - 11(Usia) + 5(BB) + 244(Sex) + 239(T) + 804(B)",
            field: "ireton_jones_2002", disabled: true
        },
        {
            label: "Ireton-Jones 1992 Original",
            keterangan: "1925 - 10(Usia) + 5(BB) + 281(Sex) + 292(T) + 851(B)",
            field: "ireton_jones_1992", disabled: true
        },
        {
            label: "Spontaneous-Breathing",
            keterangan: "629 - 11(Usia) + 25(BB) - 609(Obesitas)",
            field: "spontaneous_breathing", disabled: true
        },
    ];

    const rumusEnergiCepat = [
        { label: "Energi berapa kcal/kgBB?", field: "EnergiberapakcalkgBB" },
        { label: "Energi (kcal)", field: "energi_kcal", disabled: true },

    ];


    const renderJudul = () => (
        <div className="col-sm-12 bg-warning">
            <div className='row border p-2'>
                <div className="col-sm-3 text-right" style={{ textAlign: 'right' }}>
                    <label className=' text-right b'>Indikator</label>
                </div>
                <div className="col-sm-3">
                    <div className="form-group">
                        <label className='text-right b'>Data</label>
                    </div>
                </div>
                <div className="col-sm-4 b">
                    <label>Keterangan</label>
                </div>
            </div>
        </div>

    )
    function formatRibuan(angka) {
        return new Intl.NumberFormat('en-US').format(angka);
    }
    function getBMIStatus(bmi) {
        if (bmi < 18.5) {
            return "Underweight";
        } else if (bmi < 22.9) {
            return "Normal";
        } else if (bmi < 24.9) {
            return "Overweight";
        } else if (bmi < 29.9) {
            return "Obese I";
        } else {
            return "Obese II";
        }
    }

    const simpanData = () => {
        setloading(true)
        // console.log(val)
        // debugger
        frm.validateFields().then(val => {
            var pure = HAPUS_IFUNDEFINE(val)
            // delete cek.centang
            var obj = {
                konseling_id: KONSELING_ID,
                form_id: FORM_ID,
                // diet : ,
                data: {
                    ...pure,
                    // ...cheklist, 
                    // diet: pure.diet && pure.diet.length > 0 ? pure.diet.toString() : "",
                    // diitsebelumnya: pure.diitsebelumnya && pure.diitsebelumnya.length > 0 ?  pure.diitsebelumnya.toString() :"",
                }
            }
            delete obj.data.centang
            _Api.post("simpan-form-konseling", obj).then(rs => {
                msg.auto(rs.data)
                setloading(false)

            })
        }).catch(err => {
            setloading(false)
            msg.error("Silahkan lengkapi data ")
        })
    }


    function hitungTBUlna(jenisKelamin, panjangUlna) {
        if (jenisKelamin == "L") {
            return ((97252 + (2645 * panjangUlna)) / 1000).toFixed(1);
        } else {
            return ((68777 + (3536 * panjangUlna)) / 1000).toFixed(1);
        }
    }

    function cekKategoriIMT(IMT) {
        if (IMT < 20) {
            return "Underweight";
        } else if (IMT < 25) {
            return "Healthy";
        } else if (IMT < 30) {
            return "Overweight";
        } else {
            return "Obese";
        }
    }


    function hitungIretonJones(usia, beratBadan, jenisKelamin, trauma, burn) {
        return 1784 - (11 * usia) + (5 * beratBadan) + (244 * (jenisKelamin === "L" ? 1 : 0)) + (239 * trauma) + (804 * burn);
    }


    function hitungIMT(berat, tinggi) {
        let tinggiMeter = tinggi / 100; // Konversi cm ke meter
        let imt = berat / (tinggiMeter * tinggiMeter); // Rumus IMT
        return imt.toFixed(1); // Hasil dengan 2 angka desimal
    }

    const hitungSemua = () => {
        var B10 = frm.getFieldValue("jeniskelamin_id")
        var B11 = frm.getFieldValue("umur")
        var B12 = frm.getFieldValue("bb")
        var B13 = frm.getFieldValue("tb")
        var B14 = frm.getFieldValue("lila")
        var B15 = frm.getFieldValue("panjang_ulna")
        var B16 = frm.getFieldValue("lingkar_betis")

        var EnergiberapakcalkgBB = frm.getFieldValue("EnergiberapakcalkgBB")

        var bb_lila = (B14 * 4) - 50
        var bb_ideal = 0.9 * (B13 - 100)
        var B18 = bb_ideal.toFixed(1);

        var imt = hitungIMT(B12, B13)

        const bmr = hitungBMR(B10, B12, B13, B11)

        const energi = EnergiberapakcalkgBB * B12


        var bb_adjusted = (((B12 - parseFloat(B18)) * 0.25) +  parseFloat(B18)).toFixed(1).toString()
        // var B19 = bb_adjusted;
        var tb_ulna = hitungTBUlna(B10, B15)
        var status_gizi_dewasa = getBMIStatus(imt)
        var status_gizi_lansia = cekKategoriIMT(imt)

        const TEEkkal = bmr * (frm.getFieldValue("faktor_aktivitas") ?? 0) * (frm.getFieldValue("faktor_stress") ?? 0)

        const burn = frm.getFieldValue("burn")
        const trauma = frm.getFieldValue("trauma")
        const obese = imt > 27 ? "1" : "0"

        const IJ2002 = hitungIretonJones(B11, B12, B10, trauma, burn)
        const IJ1992 = 1925 - (10 * B11) + (5 * B12) + (281 * (B10 == "L" ? 1 : 0)) + (292 * trauma) + (851 * burn)
        const SB = 629 - (11 * B11) + (25 * B12) - (609 * obese)

        frm.setFieldsValue({
            bb_lila: bb_lila,
            bb_ideal: bb_ideal.toFixed(1),
            bb_adjusted: bb_adjusted,
            tb_ulna: tb_ulna,
            status_gizi_dewasa: status_gizi_dewasa,
            status_gizi_lansia: status_gizi_lansia,
            imt: imt,
            obese: obese,
            bmr: formatRibuan(bmr.toString()),
            tee: formatRibuan(TEEkkal.toString()),
            ireton_jones_2002: formatRibuan(IJ2002.toString()),
            ireton_jones_1992: formatRibuan(IJ1992.toString()),
            spontaneous_breathing: formatRibuan(SB.toString()),
            energi_kcal: formatRibuan(energi.toString()),
        })

    }

    return (
        <Spin spinning={loading}>
            <h1 className='text-center text-uppercase b'> Perhitungan Energi Dewasa </h1>

            <Form form={frm}>
                <Row>
                    {/* <h3> <b>DATA UMUM & STATUS GIZI</b> </h3> */}

                    {renderJudul()}

                    {
                        objDewasa.map((v, i) => (
                            <div key={i} className="col-sm-12 hover">
                                <div className='row border pt-2'>
                                    <div className="col-sm-3 text-right" style={{ textAlign: 'right' }}>
                                        <label className=' text-right'>{v.label} : </label>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            {/* <Input_   disabled={v.disabled} name={v.field} addonAfter={v.satuan} /> */}
                                            {
                                                v.tipe == "number" ?
                                                    <Number_ format addonAfter={v.satuan} onChange={hitungSemua} disabled={v.disabled} name={v.field} />
                                                    :
                                                    <Input_ suffix={v.satuan} onChange={hitungSemua} disabled={v.disabled} name={v.field} />
                                            }

                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <label>{v.keterangan}</label>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                    <br />
                    <h3><b>RUMUS ENERGI</b></h3>

                    <h5>Rumus Energi (Mifflin St Jeor)</h5>

                    {renderJudul()}
                    {
                        rumusEnergiMiffin.map((v, i) => (
                            <div key={i} className="col-sm-12 hover">
                                <div className='row border pt-2'>
                                    <div className="col-sm-3 text-right" style={{ textAlign: 'right' }}>
                                        <label className=' text-right'>{v.label} : </label>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            {
                                                v.tipe == "number" ?
                                                    <Number_ onChange={hitungSemua} disabled={v.disabled} name={v.field} />
                                                    :
                                                    <Input_ onChange={hitungSemua} disabled={v.disabled} name={v.field} />
                                            }
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <label>{v.keterangan}</label>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                    <h5>Rumus Energi di ICU</h5>

                    {renderJudul()}
                    {
                        iretonJonesDataMCU.map((v, i) => (
                            <div key={i} className="col-sm-12 hover">
                                <div className='row border pt-2'>
                                    <div className="col-sm-3 text-right" style={{ textAlign: 'right' }}>
                                        <label className=' text-right'>{v.label} : </label>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            {
                                                v.tipe == "number" ?
                                                    <Number_ onChange={hitungSemua} disabled={v.disabled} name={v.field} />
                                                : v.tipe == "select" ?
                                                    <Select_
                                                        onChange={hitungSemua}
                                                        disabled={v.disabled}
                                                        name={v.field}
                                                        val={"value"}
                                                        caption={"value"}
                                                        option={[
                                                            { label: "Ya", value: 1 },
                                                            { label: "Tidak", value: 0 },
                                                        ]}
                                                    />
                                                :
                                                    <Input_ onChange={hitungSemua} disabled={v.disabled} name={v.field} />
                                            }
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <label>{v.keterangan}</label>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                    <h5>Rumus Energi Cepat</h5>

                    {renderJudul()}
                    {
                        rumusEnergiCepat.map((v, i) => (
                            <div key={i} className="col-sm-12 hover">
                                <div className='row border pt-2'>
                                    <div className="col-sm-3 text-right" style={{ textAlign: 'right' }}>
                                        <label className=' text-right'>{v.label} : </label>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            {
                                                v.tipe == "number" ?
                                                    <Number_ onChange={hitungSemua} disabled={v.disabled} name={v.field} />
                                                    :
                                                    <Input_ onChange={hitungSemua} disabled={v.disabled} name={v.field} />
                                            }
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <label>{v.keterangan}</label>
                                    </div>
                                </div>
                            </div>
                        ))
                    }

                    <h3 style={{ marginTop: "40px" }}> <b>KEBUTUHAN ENERGI DAN MAKRONUTRIEN</b> </h3>
                    <KebutuhanEnergiMakronutrien frm={frm} />
                </Row>
            </Form>

            {/* <Guidles /> */}
            <div className='fixed-bawah' style={{ zIndex: 9999 }}>
                <Row>
                    <Button_ sm="2" icon={<UploadOutlined />} block title="Simpan" onClick={simpanData} />
                    <Button_ color="orange" sm="2" icon={<ReloadOutlined />} title="Refresh" onClick={getCombo} />
                    <Col></Col>
                </Row>
            </div>
        </Spin>
    )
}

export default PerhitunganEnergiDewasa


